// eslint-disable-next-line no-restricted-imports
import { AccountBalance as IAccountBalance } from '@eih-netbroker/api-position';
import { atom } from 'jotai';
import { LoadableResourceLoaded, LoadableResourceLoading } from '../../types';
import { ObjectSetLoadable } from '../../utils';

export type AccountBalance = LoadableResourceLoaded & IAccountBalance;

export type AccountBalanceMaybe = LoadableResourceLoading | AccountBalance;

export const accountBalanceAtom = atom<ObjectSetLoadable<AccountBalance>>(
  new ObjectSetLoadable<AccountBalance>(accountBalance => accountBalance.accountNumber),
);
